// extracted by mini-css-extract-plugin
module.exports =  {"link":"_93444fe79c--link--ij_Qj","button":"_93444fe79c--button--QfX4r"};